// extracted by mini-css-extract-plugin
module.exports = {"container":"EndDripModal_container__BwpXE","footer":"EndDripModal_footer__18i6U"};